import { render, staticRenderFns } from "./PackageInformation.vue?vue&type=template&id=467a89b2"
import script from "./PackageInformation.vue?vue&type=script&lang=js"
export * from "./PackageInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports